export default "__VITE_ASSET__G$GjgZmd__"